export default {
    'name': 'twitter-2',
    'width': '36',
    'height': '36',
    'viewBox': '0 0 36 36',
    'data': '<path d=\'M0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18Z\' fill=\'#E1E4EB\'/><path d=\'M23.2033 9.875H25.9599L19.9374 16.7583L27.0224 26.125H21.4749L17.1299 20.4442L12.1583 26.125H9.39992L15.8416 18.7625L9.04492 9.875H14.7333L18.6608 15.0675L23.2033 9.875ZM22.2358 24.475H23.7633L13.9033 11.4383H12.2641L22.2358 24.475Z\' fill=\'#026958\'/>'
}
